import { businessWebsitePrefixes, dummyCityNames } from 'constants/new_accounts.constants';

export const splitBusinessWebsiteUrl = (url: string) => {
	const prefix = businessWebsitePrefixes.find((option) => url.toLowerCase().startsWith(option));
	return { prefix, text: prefix ? url.slice(prefix.length) : url };
};

export const isValidCityName = (value: string) => {
	const cityName = value.trim().toLowerCase();
	return cityName.length > 2 && !dummyCityNames.includes(cityName);
};
